import { Plus as PlusIcon } from 'iconoir-react'
import { ReactElement } from 'react'
import { AddContactsModal } from './AddContactsModal'
import { useIsMobile } from 'app/hooks/useMediaQuery'
import { showModal } from 'app/lib/modal'
import type { ContactJson, PipelineType, StageType } from 'app/types/entities'

/** Prominent header button that opens the multiselect Add-contacts modal. */
export function AddContactButton({
  pipeline,
  addContactsToPipeline,
}: {
  pipeline: PipelineType
  addContactsToPipeline: (contacts: ContactJson[], stage: StageType) => void
}): ReactElement {
  const hasStages = (pipeline.stages?.length ?? 0) > 0
  const isMobile = useIsMobile()
  return (
    <button
      className={isMobile ? `btn btn-tertiary btn-sm` : `btn btn-primary btn-md`}
      disabled={!hasStages}
      aria-label="Add contact"
      onClick={() =>
        showModal(<AddContactsModal pipeline={pipeline} onAdd={addContactsToPipeline} />, {
          title: `Add contacts`,
          isFullScreen: false,
          removePadding: true,
          useRadix: true,
        })
      }
    >
      <PlusIcon className="h-4 w-4" />
      {!isMobile && <span className="ml-1 text-ui-sm">Add contact</span>}
    </button>
  )
}
